import React from 'react'
import { useSelector } from 'react-redux'

import logo from '../assets/site-logo.svg'

const Header = ({ containerClassName }) => {
  const { language } = useSelector(state => state.language)

  return (
    <header className='header'>
      <div className={`header_inner ${containerClassName}`}>
        <div className='header_top-line'>
          <div className='header_logo'>
            <img src={logo} alt='' />
          </div>
          <div className='header_desc'>
            {language === 'az' && (
              <>
                Onlayn <span>ödəmə sistemi</span>
              </>
            )}
            {language === 'ru' && (
              <>
                Система <span>онлайн оплат</span>
              </>
            )}
            {language === 'en' && (
              <>
                Online <span>payment system</span>
              </>
            )}
          </div>
        </div>
      </div>
    </header>
  )
}

export default Header
